import axios from 'axios';

const instance = axios.create();

instance.interceptors.request.use(async config => {
    const {default: store} = require('../store/configureStore');

    const {baseURL, user, password} = store.getState().widget;
    config.baseURL = baseURL;
    config.auth = {
        username: user,
        password
    };
    return config;
}, error => Promise.reject(error));

export default instance;